import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OrganizationReports } from 'src/app/admin/models/analytics.model';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AnalyticsApiErrorTypes, AnalyticsApiError } from './analytics.errors';

@Injectable()
export class AnalyticsService {
  constructor(private http: HttpClient) {}

  getOrganizationReports(data: { organizationId: number; startDate: string }[]) {
    const url = `${environment.analytics.url}/internal/studio-conversation-summaries`;

    return this.http
      .post<OrganizationReports>(url, data)
      .pipe(
        catchError((error) =>
          throwError(
            new AnalyticsApiError(AnalyticsApiErrorTypes.LoadOrganizationReportsError, error),
          ),
        ),
      );
  }
}
